import React from 'react'
import PropTypes from 'prop-types'
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import theme from '../../config/styles/theme'
import exportToImage from '../../modules/utils/exports'
import { formatAmount, formatPercentage } from '../../modules/utils/formatters'
import InfoLabel from '../Labels/InfoLabel'
import { GlobalStyle, Box, Exportable } from './LineChart.styles'

Highcharts.setOptions({
  lang: {
    numericSymbols: ['MM', 'M', 'MM', 'MM']
  }
})

const LineChart = ({ categories, distribution, fileName, id, info, inputLineChartRef, year }) => {
  const options = {
    accessibility: { enabled: false },
    title: {
      text: ''
    },
    chart: {
      type: 'line'
    },
    yAxis: {
      title: {
        text: ' '
      },
      gridLineDashStyle: 'ShortDash'
    },
    xAxis: {
      categories,
      min: 0,
      gridLineDashStyle: 'ShortDash',
      gridLineWidth: 1,
      max: 11,
      startOnTick: false,
      endOnTick: false
    },
    series: info,
    tooltip: {
      borderWidth: 1,
      shadow: true,
      formatter() {
        if (distribution === 'amount' || distribution === 'totalAmount') {
          return `<strong>$${formatAmount(this.y)}</strong> transados durante el mes de ${this.x} de ${year}`
        } else if (
          distribution === 'percentage' ||
          distribution === 'percentageMonth' ||
          distribution === 'percentageAccumulative'
        ) {
          return `<strong>${formatPercentage(this.y)}</strong> transados durante el mes de ${this.x} de ${year}`
        } else {
          return `<strong>${this.y}</strong> transados hasta el mes de ${this.x} de ${year}`
        }
      }
    },
    plotOptions: {
      line: {
        lineWidth: 4
      },
      series: {
        animation: false,
        marker: {
          radius: 5,
          fillColor: theme.palette.brand.white,
          lineColor: null,
          lineWidth: 2
        }
      }
    }
  }

  const exportData = () => {
    exportToImage(id, fileName)
  }

  return (
    <>
      <GlobalStyle />
      <Exportable id={id}>
        <HighchartsReact highcharts={Highcharts} options={options} />
        <Box mb={2}>
          {info.map(item => (
            <InfoLabel key={item.name} label={item.name} color={item.color} margin="0 25px 0 0" />
          ))}
        </Box>
      </Exportable>
      <Exportable onClick={exportData} ref={inputLineChartRef} />
    </>
  )
}

LineChart.defaultProps = {
  id: 'lineChart'
}

LineChart.propTypes = {
  categories: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
  distribution: PropTypes.string,
  fileName: PropTypes.string,
  id: PropTypes.string,
  info: PropTypes.arrayOf(
    PropTypes.shape({
      amount: PropTypes.arrayOf(PropTypes.number),
      color: PropTypes.string,
      data: PropTypes.arrayOf(PropTypes.number),
      month: PropTypes.arrayOf(PropTypes.string),
      name: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      totalAmount: PropTypes.arrayOf(PropTypes.number)
    })
  ).isRequired,
  inputLineChartRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({ current: PropTypes.instanceOf(window.HTMLDivElement) })
  ]),
  year: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

export default LineChart
